import { useState, useCallback } from 'react';

const FAQPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫漫画网是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的！韩漫漫画网是一个完全免费的韩漫画免费网站，所有漫画资源均无需付费即可在线观看，致力于为广大漫画爱好者提供优质的免费阅读服务。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫漫画网有哪些类型的漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫漫画网拥有漫画大全，涵盖热血、恋爱、奇幻、悬疑、搞笑、动作、耽美、剧情等多种类型的韩国漫画，满足不同读者的阅读喜好。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在线观看漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过韩漫漫画网实现漫画完整在线观看，只需在网站首页或分类页面选择感兴趣的漫画，点击进入详情页后即可开始阅读。支持电脑和手机端访问。',
      },
    },
    {
      '@type': 'Question',
      name: '漫画更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫漫画网每日更新热门漫画的最新章节，确保读者能够及时追更。您可以在首页"最近更新"栏目中查看最新上架的漫画内容。',
      },
    },
    {
      '@type': 'Question',
      name: '网站支持哪些设备访问？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫漫画网采用响应式设计，完美适配电脑、平板和手机等各类设备，让您随时随地享受流畅的漫画阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '遇到问题如何联系客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过邮箱 contact@hanmancomic.com 联系我们，或使用在线客服功能（每日9:00-21:00），我们会尽快为您解答问题。',
      },
    },
  ],
};

const AboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于韩漫漫画网',
  description: '韩漫漫画网是一个专注于韩国漫画免费在线观看的平台，拥有海量漫画资源，致力于为漫画爱好者提供最优质的阅读体验。',
  url: 'https://www.hanmancomic.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫漫画网',
    url: 'https://www.hanmancomic.com/',
  },
};

const reviews = [
  {
    name: '漫画迷小王',
    avatar: '王',
    rating: 5,
    comment: '一直在找好用的韩漫网站，韩漫漫画网真的太棒了！更新速度快，画质清晰，而且完全免费，已经推荐给身边所有朋友了。',
    date: '2026-07-28',
  },
  {
    name: '阅读达人',
    avatar: '李',
    rating: 5,
    comment: '漫画大全很齐全，分类清晰找漫画特别方便。最爱的几部韩漫这里都有，漫画完整在线观看体验一流，强烈推荐！',
    date: '2026-07-20',
  },
  {
    name: '追漫小白',
    avatar: '张',
    rating: 4,
    comment: '作为刚入坑的新人，韩漫漫画网的操作界面很友好，很容易就找到了想看的漫画。每天都有更新，追漫太幸福了。',
    date: '2026-07-15',
  },
  {
    name: '老漫友',
    avatar: '陈',
    rating: 5,
    comment: '用了很多漫画网站，韩漫漫画网是体验最好的。加载速度快，没有烦人的广告，真正做到了韩漫画免费网站的承诺。',
    date: '2026-07-10',
  },
  {
    name: '资深读者',
    avatar: '刘',
    rating: 5,
    comment: '作为一个看了十年韩漫的老读者，韩漫漫画网的资源丰富度让我惊喜。无论是热门新作还是经典老漫，都能在这里找到。',
    date: '2026-07-05',
  },
  {
    name: '漫画少女',
    avatar: '赵',
    rating: 4,
    comment: '恋爱和耽美分类做得特别好，推荐的漫画都很对胃口。每天都来刷更新，韩漫漫画网已经成了我的每日必逛网站。',
    date: '2026-06-28',
  },
];

export default function About() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: '',
    website_alt: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;

    if (honeypot && honeypot.trim() !== '') {
      setSubmitStatus('success');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9pc52iftmtnfcfh0ke0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(Object.fromEntries(formData) as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setContactForm({ name: '', email: '', message: '', website_alt: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    }
  }, []);

  const stars = (n: number) => Array.from({ length: 5 }, (_, i) => i < n);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([AboutPageSchema, FAQPageSchema]),
        }}
      />

      <div className="w-full px-4 md:px-6 py-8 bg-background-50">
        <div className="max-w-7xl mx-auto">
          {/* Hero */}
          <section className="text-center mb-12">
            <h1 className="text-2xl md:text-4xl font-heading text-foreground-950 font-bold mb-4">
              关于韩漫漫画网
            </h1>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
              韩漫漫画网是一个专注于<strong>韩漫画免费网站</strong>的在线平台，致力于为全球漫画爱好者提供最优质的韩国漫画阅读体验。
              自成立以来，我们始终坚持<strong>漫画完整在线观看</strong>的免费服务理念，打造最全面的<strong>漫画大全</strong>。
            </p>
          </section>

          {/* Brand Story */}
          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-950 font-bold mb-6 flex items-center gap-2">
              <i className="ri-bookmark-line text-primary-500"></i>
              品牌故事
            </h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="w-full md:w-1/2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cozy%20reading%20room%20with%20bookshelves%20full%20of%20comics%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20comfortable%20armchair%2C%20reading%20atmosphere%2C%20soft%20warm%20amber%20and%20cream%20tones%2C%20clean%20modern%20illustration&width=800&height=500&seq=about-brand-01&orientation=landscape"
                    alt="韩漫漫画网品牌故事"
                    className="w-full rounded-lg"
                    loading="lazy"
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    韩漫漫画网的创始团队由一群热爱韩国漫画的资深读者组成。我们发现很多漫画爱好者面临着找漫难、阅读体验差的问题，于是决定打造一个真正为读者着想的<strong>韩漫画免费网站</strong>。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    经过数年的积累与发展，韩漫漫画网已经成长为业内知名的漫画阅读平台，拥有涵盖热血、恋爱、奇幻、悬疑等八大类型的<strong>漫画大全</strong>，为数百万读者提供<strong>漫画完整在线观看</strong>服务。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    我们的使命是让每一位漫画爱好者都能轻松找到并享受自己喜欢的漫画，让阅读变得更加简单、快乐。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Core Values */}
          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-950 font-bold mb-6 flex items-center gap-2">
              <i className="ri-star-line text-accent-500"></i>
              核心优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-book-open-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">海量资源</h3>
                <p className="text-xs text-foreground-600">收录数万部热门韩漫，涵盖多种类型，<strong>漫画大全</strong>随心选</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-speed-up-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">极速更新</h3>
                <p className="text-xs text-foreground-600">每日同步更新热门漫画最新章节，追更不等待</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-smartphone-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">全端适配</h3>
                <p className="text-xs text-foreground-600">电脑、平板、手机完美适配，随时随地<strong>漫画完整在线观看</strong></p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">永久免费</h3>
                <p className="text-xs text-foreground-600">真正的<strong>韩漫画免费网站</strong>，无需付费，所有漫画畅享阅读</p>
              </div>
            </div>
          </section>

          {/* Reviews */}
          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-950 font-bold mb-6 flex items-center gap-2">
              <i className="ri-chat-heart-line text-secondary-500"></i>
              读者口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {reviews.map((review, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-sm font-bold text-primary-600 shrink-0">
                      {review.avatar}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                      <div className="flex items-center gap-0.5">
                        {stars(review.rating).map((filled, j) => (
                          <i
                            key={j}
                            className={`text-xs ${filled ? 'ri-star-fill text-secondary-500' : 'ri-star-line text-foreground-300'}`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{review.comment}</p>
                  <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground-950 font-bold mb-6 flex items-center gap-2">
              <i className="ri-mail-send-line text-primary-500"></i>
              联系我们
            </h2>
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form="true"
                  className="bg-background-100 rounded-lg p-6 space-y-4"
                >
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">您的姓名</label>
                    <input
                      type="text"
                      name="name"
                      value={contactForm.name}
                      onChange={(e) => setContactForm((p) => ({ ...p, name: e.target.value }))}
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                    <input
                      type="email"
                      name="email"
                      value={contactForm.email}
                      onChange={(e) => setContactForm((p) => ({ ...p, email: e.target.value }))}
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      name="message"
                      value={contactForm.message}
                      onChange={(e) => setContactForm((p) => ({ ...p, message: e.target.value }))}
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                      placeholder="请输入您的留言（不超过500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">{contactForm.message.length}/500</p>
                  </div>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 text-white rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送留言
                  </button>

                  {submitStatus === 'success' && (
                    <p className="text-sm text-accent-500 text-center font-medium">留言已发送成功，我们会尽快回复您！</p>
                  )}
                  {submitStatus === 'error' && (
                    <p className="text-sm text-red-500 text-center font-medium">发送失败，请稍后重试。</p>
                  )}
                </form>
              </div>

              <div className="lg:w-80 shrink-0 space-y-4">
                <div className="bg-background-100 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-3">联系方式</h3>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                        <i className="ri-mail-line text-primary-500"></i>
                      </div>
                      <p className="text-sm text-foreground-700">contact@hanmancomic.com</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                        <i className="ri-customer-service-2-line text-accent-500"></i>
                      </div>
                      <p className="text-sm text-foreground-700">每日 9:00 - 21:00</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 shrink-0">
                        <i className="ri-map-pin-line text-secondary-500"></i>
                      </div>
                      <p className="text-sm text-foreground-700">在线服务平台，全球服务</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-3">常见问题</h3>
                  <div className="space-y-3">
                    {FAQPageSchema.mainEntity.slice(0, 4).map((faq, i) => (
                      <details key={i} className="group">
                        <summary className="text-sm text-foreground-700 cursor-pointer hover:text-primary-500 transition-colors">
                          {faq.name}
                        </summary>
                        <p className="text-xs text-foreground-500 mt-2 ml-2 leading-relaxed">
                          {faq.acceptedAnswer.text}
                        </p>
                      </details>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}